import { keys } from './keys';

export const en = {
  [keys.form.seoDescription]: 'Contact with us to join our team. Decal Spain SAU is an equal opportunity employer.',
  [keys.form.fullname]: 'Full Name',
  [keys.form.email]: 'Email',
  [keys.form.interestAreas]: 'Interest Areas',
  [keys.form.message]: 'Message',
  [keys.form.resume]: 'Resume',
  [keys.form.acceptPrivacyPolicy]: 'I have read and accept the <0>Privacy Policy</0>',
  [keys.form.button]: 'Send',
  [keys.snackbar.success]: 'Thank you for contact with us!',
  [keys.snackbar.error]: 'Please try later, something was wrong :(',
};
